import React from 'react';
import { MapPinIcon, TreesIcon, TargetIcon, HomeIcon, ArrowRightIcon } from 'lucide-react';
export function AboutSection() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1569">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-1570">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start" data-id="element-1571">
          <div className="flex-1" data-id="element-1572">
            <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1573">
              Est. 1953 · Fenton, Michigan
            </p>
            <h2 className="text-3xl md:text-4xl font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1574">
              About the Club
            </h2>
            <div className="section-divider" data-id="element-1575" />
            <p className="text-base leading-relaxed mb-6" style={{
            color: '#3a3a3a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1576">
              Fenton Lakes Sportsman's Club is set on more than 70 acres of
              rolling Michigan countryside, just north of Fenton. Since 1953,
              we've been serving our community by protecting natural resources
              and supporting fellow sportsmen — offering world-class facilities
              for shooting, archery, and outdoor recreation.
            </p>
            <p className="text-base leading-relaxed mb-8" style={{
            color: '#3a3a3a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1577">
              Our clubhouse is available for private events including meetings,
              receptions, graduations, parties, and luncheons — accommodating up
              to 300 guests, with use of our outdoor pavilion included.
            </p>
            <a href="/ClubhouseRental.html" className="inline-flex items-center gap-2 px-6 py-3 rounded font-semibold text-sm transition-all hover:opacity-90" style={{
            backgroundColor: '#1e3d2f',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1578">
              Clubhouse Rentals &amp; Photos
              <ArrowRightIcon size={15} data-id="element-1579" />
            </a>
          </div>

          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1580">
            <div className="rounded-xl p-5" style={{
            backgroundColor: '#ffffff',
            border: '1px solid #ede9e0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
          }} data-id="element-1581">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3" style={{
              backgroundColor: '#f0f7f3'
            }} data-id="element-1582">
                <TargetIcon size={20} style={{
                color: '#1e3d2f'
              }} data-id="element-1583" />
              </div>
              <h3 className="text-base font-bold uppercase mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-1584">
                Indoor Pistol Range
              </h3>
              <p className="text-sm" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1585">
                6-lane indoor range, 50 feet. Available to members 24 hours a
                day, 7 days a week.
              </p>
            </div>

            <div className="rounded-xl p-5" style={{
            backgroundColor: '#ffffff',
            border: '1px solid #ede9e0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
          }} data-id="element-1586">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3" style={{
              backgroundColor: '#f0f7f3'
            }} data-id="element-1587">
                <TreesIcon size={20} style={{
                color: '#1e3d2f'
              }} data-id="element-1588" />
              </div>
              <h3 className="text-base font-bold uppercase mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-1589">
                Outdoor Ranges
              </h3>
              <p className="text-sm" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1590">
                25, 50, and 100 yard ranges for Rifle, Pistol, Muzzle Loaders,
                and Shotgun.
              </p>
            </div>

            <div className="rounded-xl p-5" style={{
            backgroundColor: '#ffffff',
            border: '1px solid #ede9e0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
          }} data-id="element-1591">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3" style={{
              backgroundColor: '#f0f7f3'
            }} data-id="element-1592">
                <MapPinIcon size={20} style={{
                color: '#1e3d2f'
              }} data-id="element-1593" />
              </div>
              <h3 className="text-base font-bold uppercase mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-1594">
                70+ Acres
              </h3>
              <p className="text-sm" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1595">
                Rolling countryside north of Fenton, MI. Archery, 3-D Archery,
                Axe &amp; Knife Throwing.
              </p>
            </div>

            <div className="rounded-xl p-5" style={{
            backgroundColor: '#ffffff',
            border: '1px solid #ede9e0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
          }} data-id="element-1596">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3" style={{
              backgroundColor: '#f0f7f3'
            }} data-id="element-1597">
                <HomeIcon size={20} style={{
                color: '#1e3d2f'
              }} data-id="element-1598" />
              </div>
              <h3 className="text-base font-bold uppercase mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-1599">
                Clubhouse Events
              </h3>
              <p className="text-sm" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1600">
                Up to 300 guests. Available for meetings, receptions,
                graduations, parties &amp; more.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}